<div contenteditable="false" (focusout)="onBlur()" (focusin)="onFocus()">
  <p-editor
    #editor
    (click)="$event.stopPropagation()"
    [(ngModel)]="text"
    [modules]="quillModules"
    (onInit)="$event.editor.focus()"
    (onTextChange)="onTextChanged($event)"
    [style]="{ 'min-height': height * 3 + 'rem', 'max-height': 'calc(80vh - 180px)', 'overflow-y': 'auto' }"
    [readonly]="readOnly"
  >
    <ng-template pTemplate="header">
      <span class="ql-formats">
        <select class="ql-size">
          <option value="small"></option>
          <option selected></option>
          <option value="large"></option>
        </select>
        <select class="ql-font">
          <option selected></option>
          <option value="serif"></option>
          <option value="monospace"></option>
        </select>
      </span>

      <span class="ql-formats">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
      </span>

      <span class="ql-formats">
        <button class="ql-list" value="ordered"></button>
        <button class="ql-list" value="bullet"></button>
      </span>

      <span class="ql-formats">
        <button class="ql-clean" value="bullet"></button>
      </span>
    </ng-template>
  </p-editor>
  <button
    *ngIf="showSaveButton && !readOnly"
    pButton
    (click)="save()"
    [label]="saveButtonLabel"
    icon="pi pi-check"
    class="mt-3"
    [disabled]="mandatory && !text"
  ></button>
</div>
